import React from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Input } from "../../../../../library/input";
import { Label } from "../../../../../library/label";
import { Select } from "../../../../../library/select";
import { Textarea } from "../../../../../library/textarea";

const Index = ({ companyOpportunity, setCompanyOpportunity }) => {
  const units = useSelector(
    (state) =>
      state.pipeline.activePipeline && state.pipeline.activePipeline.units
  );

  const renderPhases = () => {
    const phases = [
      {
        id: 0,
        value: "",
        title: "Velg",
        selected: true,
        disabled: true,
      },
    ];
    units &&
      units.map((unit, index, arr) => {
        phases.push({
          id: unit.id,
          key: unit.id,
          value: unit.id,
          title: unit.name,
          unitId: unit.id,
        });
      });
    return phases;
  };

  return (
    <div className="company-unit-details">
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Bedriftsnavn
          </Label>
          <Input
            value={companyOpportunity.name}
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                name: e.target.value,
              })
            }
            placeholder="Bedriftsnavn"
            type="text"
          />
        </Col>
      </Row>
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Tittel
          </Label>
          <Input
            value={companyOpportunity.title}
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                title: e.target.value,
              })
            }
            placeholder="Mitt produkt"
            type="text"
          />
        </Col>
      </Row>
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Beløp
          </Label>
          <Input
            format="amount"
            value={companyOpportunity.amount}
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                amount: e.target.value,
              })
            }
            placeholder="10 000"
            type="text"
          />
        </Col>
      </Row>
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Beskrivelse
          </Label>
          <Textarea
            value={companyOpportunity.description}
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                description: e.target.value,
              })
            }
            rows={3}
            placeholder="Beskrivelse av produktet du selger."
          />
        </Col>
      </Row>
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Kontaktperson
          </Label>
          <Input
            value={companyOpportunity.contactPerson}
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                contactPerson: e.target.value,
              })
            }
            placeholder="Gavin Belson"
            type="text"
          />
        </Col>
      </Row>
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Salgsfase
          </Label>
          <Select
            onChange={(e) =>
              setCompanyOpportunity({
                ...companyOpportunity,
                unit: e.target.value,
              })
            }
            items={renderPhases()}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Index;
